import * as Joi from "joi";
import { Entity, OneToMany } from 'typeorm';
import { GenPartial } from 'typeormgen';
import Base from '../base.entity';
import Episodic from '../episodics/episodic.entity';

@Entity('series')
export default class Series extends Base {
	@OneToMany((type) => Episodic, (episodic) => episodic.series)
	episodics: Episodic[];

	static rules() {
		return {
			id: Joi.number().integer(),
		};
	}

	toJSON() {
		return {
			id: this.id,
		};
	}

	constructor(props?: GenPartial<Series>) {
		super(props);
	}
}
